import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../../../core';
import { ClienteInternetFilter } from '../filter';
import { ClienteInternetSearchTotal } from '../cliente-internet-search-total';
import { ClienteInternetSearch } from '../cliente-internet-search';
import { ClienteInternet } from '../cliente-internet';

@Injectable({
    providedIn: 'root'
})
export class ClienteInternetHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/cliente`;
    }

    /** Obtem os totais para a pesquisa das informações de internet dos clientes */
    getSearchTotal(filter: ClienteInternetFilter): Observable<ClienteInternetSearchTotal> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteInternetSearchTotal>(`${this.pathApi}/0/internet/total`, {params});
    }

    /** Realiza a pesquisa das informações de internet dos clientes */
    search(filter: ClienteInternetFilter, limit: number, offset: number): Observable<ClienteInternetSearch[]> {
        // Params
        let params = new HttpParams()
                            .append('limit', limit ? limit.toString() : null)
                            .append('offset', offset ? offset.toString() : null);
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }
        return this.customHttp.get<ClienteInternetSearch[]>(`${this.pathApi}/0/internet`, {params});
    }

    /** Carrega os dados de internet do cliente informado */
    load(id: number): Observable<ClienteInternet> {
        return this.customHttp.get<ClienteInternet>(`${this.pathApi}/${id}/internet/load`);
    }

    /** Atualiza as informações de internet do cliente */
    update(entity: ClienteInternet): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${entity.id}/internet`, entity, {responseType: 'text'});
    }
}
